import { connect } from 'react-redux';

import type { RootState } from 'src/reducers/index';

import { DontHavePasswordLink } from './DontHavePasswordLink';

export const mapStateToProps = (state: RootState) => ({
  pageAnalytics: state.page.pageAnalytics,
  userDetails: state.user?.userDetails,
});

export default connect(mapStateToProps, {})(DontHavePasswordLink);
